export const DEFAULT_VARIANT_KEY = ''
export const OPACITY_OVERRIDE = 0.4

export const TRANSPARENT_EDIT_STYLE = {
	position: 'absolute',
	top: '0',
	content: `''`,
	height: '100%',
	width: '100%',
	'background-size': '16px 16px',
	'background-position': `0 0, 8px 8px`,
	'background-image': `
		linear-gradient(45deg, #bebebe66 25%, transparent 25%, transparent 75%, #bebebe66 75%, #bebebe66),
		linear-gradient(45deg, #bebebe66 25%, transparent 25%, transparent 75%, #bebebe66 75%, #bebebe66)`,
	'pointer-events': 'none',
}

export const RESET_TRANSPARENT = {
	position: 'inherit',
	top: 'inherit',
	content: 'inherit',
	'background-image': 'inherit',
	'background-position': 'inherit',
	'background-size': 'inherit',
}
